import { useRouterPush } from '~/src/hooks/router/useRouterPush'
import { useEoValue } from '~/src/hooks/useEoState'
import Params from '~/src/router/enums/params.enum'
import { AUTHENTICATION_STATE } from '~/src/stores/authentication'
import useGuestFormFields from '~/src/hooks/forms/guest-form/useGuestFormFields'
import { useLocation } from 'react-router-dom'
import { GuestMissingFieldsDialogProps } from '~/src/components/auth/dialogs/missing-fields/GuestMissingFieldsDialog'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

const useReLoginAsGuestEffect = () => {
  const { pathname } = useLocation()
  const { push } = useRouterPush()
  const authenticationState = useEoValue(AUTHENTICATION_STATE)
  const { isRequired } = useGuestFormFields()
  const { goToStep } = useAuthenticationFlowDialogs()

  const check = () => {
    if (authenticationState.loggedInAs !== 'guest') {
      return
    }

    if (
      ((isRequired('phone') && authenticationState.guest?.phone) || !isRequired('phone'))
      && ((isRequired('name') && authenticationState.guest?.firstName && authenticationState.guest?.lastName) || !isRequired('name'))
      && ((isRequired('email') && authenticationState.guest?.email) || !isRequired('email'))
      && ((isRequired('company') && authenticationState.guest?.company) || !isRequired('company'))
    ) {
      return
    }

    push(`${pathname}?${Params.REDIRECT_TO}=CHECKOUT`)

    return goToStep<GuestMissingFieldsDialogProps>(
      AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_GUEST_MISSING_FIELDS,
      {
        showBackButton: false
      }
    )
  }

  return { check }
}

export default useReLoginAsGuestEffect
